// The API stores immutable WhatsApp revisions as integers starting at 1.
// Keep those identifiers unchanged when sending requests or pinning campaigns.
export const formatWhatsAppTemplateVersion = (value) => {
  const version = Number(value);
  if (!Number.isSafeInteger(version) || version < 1) return "—";
  return `v.${((version - 1) / 10).toFixed(1)}`;
};
